/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo, useRef } from 'react';

import { makeStyles, Typography, Grid } from '@material-ui/core';

import IconFaceAngryGrey from '../../assets/images/ic-face-angry-grey.svg';
import IconFaceAngry from '../../assets/images/ic-face-angry.svg';
import IconFaceFrowningGrey from '../../assets/images/ic-face-frowning-grey.svg';
import IconFaceFrowning from '../../assets/images/ic-face-frowning.svg';
import IconFaceNeutralGrey from '../../assets/images/ic-face-neutral-grey.svg';
import IconFaceNeutral from '../../assets/images/ic-face-neutral.svg';
import IconFaceSlightlySmillingGrey from '../../assets/images/ic-face-slightlysmilling-grey.svg';
import IconFaceSlightlySmilling from '../../assets/images/ic-face-slightlysmilling.svg';
import IconFaceSmillingGrey from '../../assets/images/ic-face-smilling-grey.svg';
import IconFaceSmilling from '../../assets/images/ic-face-smilling.svg';
import EditFields from '../common/EditFields';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => {
  return {
    button: {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
      padding: '12px',
      width: '100%',
      [theme.breakpoints.up('lg')]: {
        width: '140px',
      },
    },
    buttonContainer: {
      textAlign: 'right',
      width: '100%',
    },
    feedbackIcon: {
      cursor: 'pointer',
      height: 'auto',
      marginRight: '10px',
      width: '20px',
    },
    feedbackIconLast: {
      marginRight: '0px !important',
    },
    subtitle: {
      color: '#172B4D',
      fontSize: '14px',
      lineHeight: '24px',
      marginBottom: '0px',
    },
    title: {
      color: '#172B4D',
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '24px',
      marginBottom: '9px',
      textAlign: 'left',
      [theme.breakpoints.up('lg')]: {
        marginBottom: '10px',
      },
    },
  };
});

const PatientVideoReportRating = ({ reportRate, loadingButton$, onReportRateChange, onSubmit }) => {
  const classes = useStyles();
  const commentFieldRef = useRef();

  const commentField = useMemo(
    () => [
      {
        className: `custom-height small-text`,
        disabled: reportRate?.submitted,
        multiline: true,
        name: 'ratingComment',
        onChange: (value, isValid) => {
          handleFieldChange('ratingComment', value);
        },
        placeholder: reportRate?.submitted
          ? 'No comment provided'
          : 'We would love to know if you are satisfied with your video report and if there was anything we could do to improve our offering.',
        rows: 5,
        rowsMax: 5,
        type: 'text',
        variant: 'outlined',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [reportRate]
  );

  const icon = [
    reportRate.ratingScore === 1 ? IconFaceAngry : IconFaceAngryGrey,
    reportRate.ratingScore === 2 ? IconFaceFrowning : IconFaceFrowningGrey,
    reportRate.ratingScore === 3 ? IconFaceNeutral : IconFaceNeutralGrey,
    reportRate.ratingScore === 4 ? IconFaceSlightlySmilling : IconFaceSlightlySmillingGrey,
    reportRate.ratingScore === 5 ? IconFaceSmilling : IconFaceSmillingGrey,
  ];

  const isButtonEnabled = !!reportRate.ratingScore;

  const handleFieldChange = (field, value) => {
    if (!onReportRateChange || typeof onReportRateChange !== 'function' || reportRate.submitted) return;
    onReportRateChange(field, value);
  };

  const handleSubmit = () => {
    if (!onSubmit || typeof onSubmit !== 'function' || reportRate.submitted) return;
    onSubmit();
  };

  return (
    <div>
      <Typography className={classes.title}>Video Report Rating</Typography>
      <Grid container alignItems="center" justify="space-between">
        <Grid item>
          <Typography className={classes.subtitle}>How do you like us?</Typography>
        </Grid>
        <Grid item>
          <Grid container>
            <Grid item>
              <img onClick={() => handleFieldChange('ratingScore', 1)} className={`${classes.feedbackIcon}`} src={icon[0]} alt="feedback angry" />
            </Grid>
            <Grid item>
              <img onClick={() => handleFieldChange('ratingScore', 2)} className={`${classes.feedbackIcon}`} src={icon[1]} alt="feedback frowning" />
            </Grid>
            <Grid item>
              <img onClick={() => handleFieldChange('ratingScore', 3)} className={`${classes.feedbackIcon}`} src={icon[2]} alt="feedback neutral" />
            </Grid>
            <Grid item>
              <img onClick={() => handleFieldChange('ratingScore', 4)} className={`${classes.feedbackIcon}`} src={icon[3]} alt="feedback slightly smilling" />
            </Grid>
            <Grid item>
              <img onClick={() => handleFieldChange('ratingScore', 5)} className={`${classes.feedbackIcon} ${classes.feedbackIconLast}`} src={icon[4]} alt="feedback smilling" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <div>
        <EditFields data={reportRate} useLabel={false} labelPosition="top" ref={commentFieldRef} fields={commentField} />
      </div>

      {!reportRate?.submitted && (
        <div className={classes.buttonContainer}>
          <LoadingButton color="primary" variant="contained" onClick={handleSubmit} disabled={!isButtonEnabled} className={classes.button} loading$={loadingButton$}>
            Submit
          </LoadingButton>
        </div>
      )}
    </div>
  );
};

export default PatientVideoReportRating;
